var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.48702 0.813965C1.77389 0.813965 0 2.59882 0 4.94476C0 7.2389 1.72105 9.07466 4.38291 9.07466H4.4344C7.20059 9.07466 8.92209 7.2389 8.92209 4.94476C8.87038 2.59882 7.20059 0.813965 4.48702 0.813965V0.813965Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.46875 12.3386H8.40035V36.2451H0.46875V12.3386Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8689 11.7776C23.5901 11.7776 20.7209 15.8057 20.7209 15.8057V12.3387H12.7891V36.2452H20.7204V22.8949C20.7204 22.1801 20.7722 21.4666 20.9817 20.9555C21.5551 19.5283 22.86 18.0498 25.0512 18.0498C27.9213 18.0498 29.0691 20.2421 29.0691 23.4559V36.2452H37.0001V22.5376C37.0001 15.1946 33.0869 11.7776 27.8689 11.7776V11.7776Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinDesktop);
export default __webpack_public_path__ + "static/media/linkedin_desktop.a4d7828f.svg";
export { ForwardRef as ReactComponent };